import React, { useState, useEffect, useRef } from "react";
import SuccessModal from "./SuccessModal";
import { useOutletContext } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa";
import config from "../../../config/config";
import axios from "axios";

const IndicativeRatesComponent = ({ user }) => {
  const [rates, setRates] = useState({
    Weekday: "",
    "Night Shift": "",
    Saturday: "",
    Sunday: "",
    "Full Day": "",
  });
  const [checkedDays, setCheckedDays] = useState({
    Weekday: false,
    "Night Shift": false,
    Saturday: false,
    Sunday: false,
    "Full Day": false,
  });

  const weekdayRef = useRef(null);
  const nightShiftRef = useRef(null);
  const saturdayRef = useRef(null);
  const sundayRef = useRef(null);
  const session24HrRef = useRef(null);
  const initialGreetingSessionRef = useRef(null);
  const [validationMessages, setValidationMessages] = useState({
    "Night Shift": "",
    Weekday: "",
    Saturday: "",
    Sunday: "",
    "Full Day": "",
    "Initial Greeting": "",
  });

  const baseURL = config.API_BASE_URL;

  const { isSmallScreen, handleBackClick } = useOutletContext();

  useEffect(() => {
    const fetchUserData = async () => {
      if (user && user.id) {
        try {
          const response = await axios.get(
            `${baseURL}/v1/worker-users/${user.id}`
          );
          const fetchedUserData = response.data;

          if (fetchedUserData && fetchedUserData.serviceRates) {
            setRates({
              "Night Shift": fetchedUserData.serviceRates["Night Shift"] || "",
              Weekday: fetchedUserData.serviceRates.Weekday || "",
              Saturday: fetchedUserData.serviceRates.Saturday || "",
              Sunday: fetchedUserData.serviceRates.Sunday || "",
              "Full Day": fetchedUserData.serviceRates["Full Day"] || "",
            });

            const updatedCheckedDays = {
              "Night Shift": !!fetchedUserData.serviceRates["Night Shift"],
              Weekday: !!fetchedUserData.serviceRates.Weekday,
              Saturday: !!fetchedUserData.serviceRates.Saturday,
              Sunday: !!fetchedUserData.serviceRates.Sunday,
              "Full Day": !!fetchedUserData.serviceRates["Full Day"],
            };
            setCheckedDays(updatedCheckedDays);

            const initialSessionRate =
              fetchedUserData.serviceRates["Initial greeting session"];
            const rateValue = parseFloat(initialSessionRate);

            setInitialGreetingSessionRate(initialSessionRate || "");
            setNoFeeForInitialGreetingSession(rateValue <= 0);
          }
        } catch (error) {
          console.error("Failed to fetch user data:", error);
        }
      }
    };

    fetchUserData();
  }, [user, baseURL]);

  const [noFeeForInitialGreetingSession, setNoFeeForInitialGreetingSession] =
    useState(true);
  const [initialGreetingSessionRate, setInitialGreetingSessionRate] =
    useState("");
  const [showModal, setShowModal] = useState(false);

  const handleNoFeeForInitialGreetingSessionChange = () => {
    setNoFeeForInitialGreetingSession((prevState) => !prevState);
  };

  const handleInitialGreetingSessionRateChange = (e) => {
    setInitialGreetingSessionRate(e.target.value);
  };

  const handleRateChange = (day, value) => {
    const currencyPattern = /^\d+(\.\d{0,2})?$/;

    if (!value || currencyPattern.test(value)) {
      setRates((prevRates) => ({
        ...prevRates,
        [day]: value,
      }));
    }
  };

  const handleCheckboxChange = (day) => {
    setCheckedDays((prevCheckedDays) => ({
      ...prevCheckedDays,
      [day]: !prevCheckedDays[day],
    }));

    if (day === "Weekday" && !checkedDays[day]) {
      weekdayRef.current.focus();
    } else if (day === "Night Shift" && !checkedDays[day]) {
      nightShiftRef.current.focus();
    } else if (day === "Saturday" && !checkedDays[day]) {
      saturdayRef.current.focus();
    } else if (day === "Sunday" && !checkedDays[day]) {
      sundayRef.current.focus();
    } else if (day === "Full Day" && !checkedDays[day]) {
      session24HrRef.current.focus();
    }
  };

  const getServiceRates = () => {
    const ratesObject = {};
    Object.keys(checkedDays).forEach((day) => {
      if (checkedDays[day]) {
        ratesObject[day] = rates[day];
      }
    });

    ratesObject["Initial greeting session"] = noFeeForInitialGreetingSession
      ? "0"
      : initialGreetingSessionRate;

    console.log(ratesObject);
    return ratesObject;
  };

  const validateRates = () => {
    let isValid = true;
    const newValidationMessages = {
      Weekday: "",
      "Night Shift": "",
      Saturday: "",
      Sunday: "",
      "Full Day": "",
      "Initial Greeting": "",
    };

    Object.keys(checkedDays).forEach((day) => {
      if (
        checkedDays[day] &&
        (!rates[day] || !/^\d+(\.\d{0,2})?$/.test(rates[day]))
      ) {
        newValidationMessages[day] = "Enter a valid rate *";
        isValid = false;
      }
    });

    if (
      !noFeeForInitialGreetingSession &&
      (!initialGreetingSessionRate ||
        !/^\d+(\.\d{0,2})?$/.test(initialGreetingSessionRate))
    ) {
      newValidationMessages["Initial Greeting"] = "Enter a valid rate *";
      isValid = false;
    }

    setValidationMessages(newValidationMessages);
    return isValid;
  };

  const handleUpdateRates = async () => {
    if (!validateRates()) {
      console.error("Validation failed.");
      return;
    }
    const ratesObject = getServiceRates();
    try {
      const updateUserResponse = await axios.patch(
        `${baseURL}/v1/worker-users/${user.id}`,
        {
          rates: ratesObject,
        }
      );

      if (updateUserResponse.data) {
        console.log("Rates update successful");
        setShowModal(true);
      } else {
        console.log("Rates update succeeded but no data returned");
      }
    } catch (error) {
      console.error("Failed to update rates:", error);
    }
  };

  const greetingSessionLabelText = noFeeForInitialGreetingSession
    ? "I offer a free Meet and Greet Session"
    : "Set Meet and Greet (M&G) session rate ( Enter 0 If you offer free Session )";

  return (
    <div className="indicative-rate-custom-component-container">
      {showModal && <SuccessModal />}
      <div className="rate-indicative-above-div1">
        <div className="profile-back-container">
          {isSmallScreen && (
            <div className="profile-back-arrow" onClick={handleBackClick}>
              <FaAngleLeft className="profile-back-icon" />
            </div>
          )}
          <h2>Service rates</h2>        
        </div>

        <p>
          Indicative rates display on your profile as a guide for potential
          clients. The actual rates you agree on and include in a service
          agreement may differ slightly, based on a client`s individual service
          requirements.
        </p>
      </div>
      <div className="rate-indicative-above-div4">
        <h3>Your indicative rates</h3>
        <p>
          Take into consideration your experience, qualifications, skills and
          service types. For NDIS-funded clients, hourly rates (including their
          One Support Hub platform fee of 7.95%) must not exceed NDIS price
          limits.
        </p>
      </div>
      <div className="rate-indicative-above-div3">
        <div className="rate-selection-div">
          {["Weekday", "Night Shift", "Saturday", "Sunday", "Full Day"].map(
            (day, index) => (
              <div key={index} className="rate-entry">
                <label>
                  <input
                    type="checkbox"
                    checked={checkedDays[day]}
                    onChange={() => handleCheckboxChange(day)}
                  />
                  {day}
                </label>
                <p>
                  {day === "Full Day" ? "Set 24-Hour Rate" : "Set Hourly Rate"}
                </p>
                <div className="rate-input-wrapper">
                  <span className="rate-dollar-sign">$</span>
                  <input
                    type="text"
                    value={rates[day]}
                    disabled={!checkedDays[day]}
                    className={validationMessages[day] ? "invalid-rate" : ""}
                    ref={
                      day === "Weekday"
                        ? weekdayRef
                        : day === "Night Shift"
                          ? nightShiftRef
                          : day === "Saturday"
                            ? saturdayRef
                            : day === "Sunday"
                              ? sundayRef
                              : session24HrRef
                    }
                    onChange={(e) => handleRateChange(day, e.target.value)}
                  />
                </div>
                <div className="indicative-error">
                  {validationMessages[day]}
                </div>
              </div>
            )
          )}
        </div>
        <div className="initial-greeting">
          <p className="rate-note">
            Note: 24-Hour Flat rate covers all support (active, passive, &
            sleep) - This should be outlined in an agreement with a client.
          </p>
          <label className="meet-and-greet">
            <input
              type="checkbox"
              checked={true}
              onChange={handleNoFeeForInitialGreetingSessionChange}
            />
            {greetingSessionLabelText}
          </label>

          {!noFeeForInitialGreetingSession && (
            <div className="rate-entry">
              <div className="rate-input-wrapper">
                <span className="rate-dollar-sign">$</span>
                <input
                  type="text"
                  value={initialGreetingSessionRate}
                  onChange={handleInitialGreetingSessionRateChange}
                  ref={initialGreetingSessionRef}
                  className={
                    validationMessages["Initial Greeting"] ? "invalid-rate" : ""
                  }
                />
              </div>
              <div className="indicative-error">
                {validationMessages["Initial Greeting"]}
              </div>
            </div>
          )}
        </div>
        <div className="rate-indicative-save">
          <button onClick={handleUpdateRates}>Save and continue</button>
        </div>
      </div>
    </div>
  );
};

export default IndicativeRatesComponent;
